export const isFetching = state => state.accounts.permissionSets.fetching;
export const permissionSets = state => state.accounts.permissionSets.list;
